import { useState } from 'react';
import { AdminAIService } from '../../services/token-admin.service';

interface AIServiceFormModalProps {
  service: AdminAIService | null;
  onSave: (data: Partial<AdminAIService>) => Promise<void>;
  onClose: () => void;
}

export function AIServiceFormModal({ service, onSave, onClose }: AIServiceFormModalProps) {
  const [formData, setFormData] = useState({
    name: service?.name || '',
    cost: service?.cost || 0,
    description: service?.description || '',
    isActive: service?.isActive !== undefined ? service.isActive : true,
  });
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    setError('');

    try {
      await onSave(formData);
    } catch (err: any) {
      setError(err.message || 'Error al guardar');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{service ? '✏️ Editar Servicio de IA' : '➕ Nuevo Servicio de IA'}</h3>
          <button onClick={onClose} className="modal-close">✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nombre del servicio *</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Ej: Render 3D Interactivo"
              />
            </div>

            <div className="form-group">
              <label>Costo en tokens *</label>
              <input
                type="number"
                required
                min={1}
                value={formData.cost}
                onChange={(e) => setFormData({ ...formData, cost: parseInt(e.target.value) || 0 })}
              />
            </div>

            <div className="form-group">
              <label>Descripción</label>
              <textarea
                rows={2}
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Descripción del servicio"
                className="resize-none"
              />
            </div>

            <div className="form-group flex items-center gap-2">
              <input
                type="checkbox"
                id="isActive"
                checked={formData.isActive}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                className="w-4 h-4"
              />
              <label htmlFor="isActive" className="text-sm font-medium">Servicio activo</label>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">❌</span>
                <span>{error}</span>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn btn-secondary">Cancelar</button>
            <button type="submit" disabled={isSaving} className="btn btn-primary">
              {isSaving ? 'Guardando...' : service ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}